<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約施設：特別営業日の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>予約施設：特別営業日の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/reservation-facility-special.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 戻るボタン
        </div>
        <div class="manual-explain">
          クリックすることで予約施設画面へ戻ります。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 追加ボタン
        </div>
        <div class="manual-explain">
          クリックすることで追加画面が表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択した情報を削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Filter・属性
        </div>
        <div class="manual-explain">
          予約施設：特別営業日一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象は、開始日、営業日種別（プルダウンによるフィルタリング）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 予約施設：特別営業日一覧
        </div>
        <div class="manual-explain">
          登録済みの予約施設：特別営業日の一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。<br>
        </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/E.png"> 予約設備：特別営業日一覧
          </div>
          <div class="manual-explain">
            登録済みの予約設備：特別営業日の一覧が表示されます。<br>
            編集アイコンをクリックすることで編集画面が表示されます。<br>
          </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Reserved Facility: Explanation of Special Operating Days
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Reserved Facility: Explanation of Special Operating Days</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_reservation-facility-special.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Back Button
        </div>
        <div class="manual-explain">
          Clicking this button will take you back to the Reserved Facility screen.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Add Button
        </div>
        <div class="manual-explain">
          Clicking this button will display the Add screen.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Delete Button
        </div>
        <div class="manual-explain">
          Clicking this button will delete the selected information.<br>
          The button becomes active when the delete checkbox in the list is checked.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Filter and Attribute
        </div>
        <div class="manual-explain">
          Filters the data displayed in the Reserved Facility: Special Operating Days list.<br>
          * Filterable fields include Start Date and Operating Day Type (filtered via dropdown menu).
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Reserved Facility: Special Operating Days List
        </div>
        <div class="manual-explain">
          Displays a list of registered Reserved Facility: Special Operating Days.<br>
          Clicking the Edit icon will display the Edit screen.<br>
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>